export const winners2023 = [
  {
    id: '2023-1',
    name: '',
    organization: 'Fuse x Simas Insurtech x Simas Jiwa',
    pillar: '',
    orgUnit: '',
    title: '',
    teamMembers: [],
    description: '',
    image: '',
    award: 'Exponential Growth',
    year: 2023,
    category: '',
    linkedIn: '#',
    projectLink: '#',
    details: ``,
  },
  {
    id: '2023-2',
    name: '',
    organization: 'Waresix x APP + Sinar Mas Agri',
    pillar: '',
    orgUnit: '',
    title: '',
    teamMembers: [],
    description: '',
    image: '',
    award: 'Efficiency Excellence',
    year: 2023,
    category: '',
    linkedIn: '#',
    projectLink: '#',
    details: ``,
  },
  {
    id: '2023-3',
    name: '',
    organization: 'Berau Coal x Smartfren Business',
    pillar: '',
    orgUnit: '',
    title: '',
    teamMembers: [],
    description: '',
    image: '',
    award: 'Disruptive Technology',
    year: 2023,
    category: '',
    linkedIn: '#',
    projectLink: '#',
    details: ``,
  },
];
